export const featuredPicks = [
  {
    name: "轻效率工具箱",
    icon: "ri-tools-line",
    category: "常用工具",
    summary: "把最常被搜到的十几个小功能收进一个页面，截图、压图、转格式不用来回切换。",
    reason: "导航站里被反复点开的老面孔，胜在干脆。",
    tone: "primary",
  },
  {
    name: "慢读公开课",
    icon: "ri-graduation-cap-line",
    category: "学习资源",
    summary: "按主题整理的公开课合集，每门课配一句难度和所需时间说明，挑课不再靠猜。",
    reason: "条目说明写得实在，适合想系统补课的人。",
    tone: "secondary",
  },
  {
    name: "静音电台集",
    icon: "ri-headphone-line",
    category: "影视娱乐",
    summary: "专注与放松两套歌单常在，界面干净无弹窗，挂着当背景音很省心。",
    reason: "辅助侧重落在这里：入口干净，一点就听。",
    tone: "accent",
  },
  {
    name: "随手记事本",
    icon: "ri-sticky-note-line",
    category: "效率办公",
    summary: "打开就写的极简笔记，支持同步与标签，适合临时记录灵感与待办。",
    reason: "上手成本几乎为零，新手最不容易劝退。",
    tone: "primary",
  },
  {
    name: "本地生活通",
    icon: "ri-map-pin-2-line",
    category: "生活服务",
    summary: "办事指南、缴费入口和出行查询聚合在一起，办正事时少走几趟弯路。",
    reason: "把散落各处的办事入口收拢到一处。",
    tone: "secondary",
  },
  {
    name: "极客快评",
    icon: "ri-device-line",
    category: "数码科技",
    summary: "数码新品评测与拆解汇总，文末附真实参数对照，选购前值得刷一遍。",
    reason: "信息密度高但不啰嗦，参数党友好。",
    tone: "accent",
  },
];